import Joi from "joi";
import errorsResolver from "../../validation/schemeUtils";

const commonErrorMessages = {
  pattern: "Поле содержит недопустимые символы или их количество",
  numberGreater: "Значение должно быть больше 0",
  precision: "Допускается не более 2 знаков после запятой",
  required: "Обязательное поле",
  numberUnsafe: "Допускается не более 2 знаков после запятой",
};

const patterns = {
  generalText: `^[a-zA-Zа-яА-ЯёЁ0-9() *\\/?!%{}[\\]^<>,-.|№"_=&$#~@+'\\\\ \n\r:;«»\`]`,
  numberOnly: `^[0-9]{1,8}(\.[0-9]{0,2})?$`,
};

const commonValueSchema = {
  id: Joi.alternatives().try(Joi.string(), Joi.allow(null)),
  name: Joi.string().pattern(new RegExp(patterns.generalText)).optional().error(errorsResolver(commonErrorMessages)),
  value: Joi.string()
    .pattern(new RegExp(patterns.numberOnly))
    .required()
    .custom((value, helpers) => {
      const num = parseFloat(value);
      if (isNaN(num) || num <= 0) {
        return helpers.error("number.greater");
      }
      return num;
    })
    .error(errorsResolver(commonErrorMessages)),
};

const baseSchema = {
  values: Joi.array().items(Joi.object(commonValueSchema)).required(),
};

export const baseValueSchema = Joi.object(baseSchema);
export const industrySchema = Joi.object(baseSchema).unknown(true);
export const averageSalaryModalSchema = Joi.object(baseSchema);